module.exports = __webpack_public_path__ + "img/convert-currency.3cd61a26.png";